import { updateTemplateContent } from 'common/api/templates';

export default (updatedData) => () =>
    new Promise((resolve, reject) => {
        updateTemplateContent(
            {
                content: JSON.stringify(updatedData),
            },
            updatedData.id,
        )
            .then((response) => resolve(response.data))
            .catch((error) => reject(error.response.data.errors));
    });
